import { Link, NavLink, useLocation } from 'react-router-dom';
import { useTravelTranslation } from '../../app/TravelLocaleContext';
import {
  INBOX_IA_NOTIFICATION_SUBTYPES,
  INBOX_IA_SECONDARY,
  resolveInboxSection,
  resolveNotificationSubtype,
} from './inboxIaNav';
import './notification-center-tabs.css';

/**
 * Inbox IA v2 shell（FE-IA-V2-03）。
 * Primary owner「通知」底下：訊息 | 通知；通知內容保留 Social／揪團 subtype。
 * 不合併 IM／Notification backend；不造假 unread 加總。
 */
export default function NotificationCenterTabs({ active }) {
  const { t } = useTravelTranslation();
  const location = useLocation();
  const section = resolveInboxSection(location.pathname) || (
    active === 'messages' ? 'messages' : 'notifications'
  );
  const subtype = resolveNotificationSubtype(location.pathname, active);
  const showNotificationSubtypes = section === 'notifications';
  const showRelated = section === 'notifications';

  return (
    <div className="notification-center-shell inbox-ia-shell" data-testid="notification-center-shell" data-inbox-section={section}>
      <nav
        className="inbox-ia-secondary"
        aria-label={t('travel.nav.notificationCenter')}
        data-testid="inbox-ia-secondary-nav"
      >
        {INBOX_IA_SECONDARY.map((item) => {
          const isActive = section === item.section;
          return (
            <NavLink
              key={item.id}
              to={item.to}
              end={item.id === 'messages'}
              className={() => `inbox-ia-secondary__link${isActive ? ' is-active' : ''}`}
              aria-current={isActive ? 'page' : undefined}
              data-testid={item.testId}
            >
              {t(item.labelKey)}
            </NavLink>
          );
        })}
      </nav>

      {showNotificationSubtypes ? (
        <nav
          className="notification-center-tabs"
          aria-label={t('travel.nav.notifications')}
          data-testid="notification-center-tabs"
        >
          {INBOX_IA_NOTIFICATION_SUBTYPES.map((item) => {
            const isActive = subtype === item.active;
            return (
              <NavLink
                key={item.id}
                to={item.to}
                end
                className={() => (
                  `notification-center-tabs__link${isActive ? ' is-active' : ''}`
                )}
                aria-current={isActive ? 'page' : undefined}
                data-testid={item.testId}
              >
                {t(item.labelKey)}
              </NavLink>
            );
          })}
        </nav>
      ) : null}

      {showRelated ? (
        <nav
          className="notification-center-related"
          aria-label={t('travel.notificationCenter.relatedAria')}
          data-testid="notification-related-entries"
        >
          <p className="notification-center-related__label">
            {t('travel.notificationCenter.relatedLabel')}
          </p>
          <div className="notification-center-related__links">
            <Link
              to="/announcements"
              className={`notification-center-related__link${active === 'announcements' ? ' is-active' : ''}`}
              data-testid="notification-entry-announcements"
            >
              {t('travel.notificationCenter.announcements')}
            </Link>
            <Link
              to="/site-mail"
              className={`notification-center-related__link${active === 'siteMail' ? ' is-active' : ''}`}
              data-testid="notification-entry-site-mail"
            >
              {t('travel.notificationCenter.siteMail')}
            </Link>
          </div>
        </nav>
      ) : null}
    </div>
  );
}
